export enum InvoiceType
    {
        Annulatie,
        Afrekening,
        Voorschot
    }